export enum SUPPORTED_MODEL_TYPES {
  // AEAT
  AEAT_036_CENSO_EMPRESARIOS = "AEAT_036_CENSO_EMPRESARIOS",
  AEAT_100_RENTA = "AEAT_100_RENTA",
  AEAT_151_REGIMEN_ESPECIAL = "AEAT_151_REGIMEN_ESPECIAL",
  AEAT_111_IRPF_RENDIMIENTOS_TRABAJO_AUTOLIQUIDACION = "AEAT_111_IRPF_RENDIMIENTOS_TRABAJO_AUTOLIQUIDACION",
  AEAT_115_IRPF_RENDIMIENTO_INMUEBLES = "AEAT_115_IRPF_RENDIMIENTO_INMUEBLES",
  AEAT_130_IRPF_DIRECTA = "AEAT_130_IRPF_DIRECTA",
  AEAT_131_IRPF_OBJETIVA = "AEAT_131_IRPF_OBJETIVA",
  AEAT_180_IRPF_RENDIMIENTO_INMUEBLES_RESUMEN = "AEAT_180_IRPF_RENDIMIENTO_INMUEBLES_RESUMEN",
  AEAT_190_IRPF_RENDIMIENTOS_TRABAJO_RESUMEN = "AEAT_190_IRPF_RENDIMIENTOS_TRABAJO_RESUMEN",
  AEAT_200_IMPUESTO_SOCIEDADES = "AEAT_200_IMPUESTO_SOCIEDADES",
  AEAT_303_IVA_AUTOLIQUIDACION = "AEAT_303_IVA_AUTOLIQUIDACION",
  AEAT_309_IVA_LIQUIDACION_NO_PERIODICA = "AEAT_309_IVA_LIQUIDACION_NO_PERIODICA",
  AEAT_347_OPERACIONES_TERCEROS = "AEAT_347_OPERACIONES_TERCEROS",
  AEAT_349_IVA_OPERACIONES_INTRACOMUNITARIAS = "AEAT_349_IVA_OPERACIONES_INTRACOMUNITARIAS",
  AEAT_390_IVA_RESUMEN = "AEAT_390_IVA_RESUMEN",
  AEAT_714_IMPUESTO_PATRIMONIO = "AEAT_714_IMPUESTO_PATRIMONIO",
  AEAT_CERT_CENSAL = "AEAT_CERT_CENSAL",
  AEAT_CERT_IRPF = "AEAT_CERT_IRPF",
  AEAT_CERT_OBLIG_TRIB = "AEAT_CERT_OBLIG_TRIB",
  AEAT_IRPF_DATOS_FISCALES = "AEAT_IRPF_DATOS_FISCALES",
  AEAT_DATOS_CENSALES = "AEAT_DATOS_CENSALES",
  AEAT_DETALLE_DEUDAS = "AEAT_DETALLE_DEUDAS",
  AEAT_CERT_CENSO_ACTIVIDADES_ECONOMICAS = "AEAT_CERT_CENSO_ACTIVIDADES_ECONOMICAS",

  // DGT
  DGT_VEHICLE_DATA = "DGT_VEHICLE_DATA",
  DGT_INFORME_DATOS_CONDUCTOR = "DGT_INFORME_DATOS_CONDUCTOR",

  // Seguridad Social
  SEG_SOCIAL_RESUMEN_SITUACION = "SEG_SOCIAL_RESUMEN_SITUACION",
  SEG_SOCIAL_BASE_COTIZACIONES = "SEG_SOCIAL_BASE_COTIZACIONES",
  SEG_SOCIAL_CERT_INTEGRAL_PRESTACIONES = "SEG_SOCIAL_CERT_INTEGRAL_PRESTACIONES",
  SEG_SOCIAL_CERT_OBLIG = "SEG_SOCIAL_CERT_OBLIG",
  SEG_SOCIAL_VIDA_LABORAL = "SEG_SOCIAL_VIDA_LABORAL",
  SEG_SOCIAL_DATOS_TRABAJO_AUTONOMO = "SEG_SOCIAL_DATOS_TRABAJO_AUTONOMO",
  SEG_SOCIAL_SITUACION_ACTUAL = "SEG_SOCIAL_SITUACION_ACTUAL",
  SEG_SOCIAL_DATOS_PERSONALES = "SEG_SOCIAL_DATOS_PERSONALES",
  SEG_SOCIAL_DETALLE_DEUDAS = "SEG_SOCIAL_DETALLE_DEUDAS",

  // Carpeta ciudadana
  CARP_CIUD_JUST_EMPADRONAMIENTO = "CARP_CIUD_JUST_EMPADRONAMIENTO",
  CARP_CIUD_JUST_AUSENCIA_ANT_PENALES = "CARP_CIUD_JUST_AUSENCIA_ANT_PENALES",
  CARP_CIUD_CERT_CATASTRO = "CARP_CIUD_CERT_CATASTRO",
  CARP_CIUD_CERT_NACIMIENTO = "CARP_CIUD_CERT_NACIMIENTO",
  CARP_CIUD_DATOS_PERSONALES = "CARP_CIUD_DATOS_PERSONALES",
  CARP_CIUD_TITULOS_UNIVERSITARIOS = "CARP_CIUD_TITULOS_UNIVERSITARIOS",
  CARP_CIUD_TITULOS_NO_UNIVERSITARIOS = "CARP_CIUD_TITULOS_NO_UNIVERSITARIOS",

  // Forales
  NAVARRA_F93 = "NAVARRA_F93",
  VIZCAYA_100_RENTA = "VIZCAYA_100_RENTA",
  GUIPUZCOA_109_RENTA = "GUIPUZCOA_109_RENTA",
  ALAVA_100_RENTA = "ALAVA_100_RENTA",

  // Supramodel
  HACIENDA_RENTA = "HACIENDA_RENTA",

  // BDE
  BDE_CIRBE = "BDE_CIRBE",
}
